import { useTemplateRenderToString } from "app/utils/hooks/useTemplateRender";
import { htmlSanitize } from "app/utils/sanitize";

/**
 * Resolves the template tokens of CMS rich text and returns it as one sanitized HTML string,
 * without block wrappers, so it can fill an inline context such as a heading.
 */
export const useInlineHtml = (paragraphs: string | string[] = []) => {
	const templateRenderToString = useTemplateRenderToString();
	const lines = Array.isArray(paragraphs) ? paragraphs : [paragraphs];
	const html = lines.map(line => String(templateRenderToString(line))).join("");

	return htmlSanitize(html);
};
